var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-button"},[_c('Button',{attrs:{"icon":_vm.icon,"disabled":_vm.disabled},on:{"click":function($event){_vm.disabled ? '' : _vm.$emit('click', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }